import type { Comment } from '../types'

export const comments: Comment[] = [
  {
    id: 'c1',
    postId: 'p1',
    authorId: 'marina',
    text: {
      'pt-BR': 'Esse horário muda tudo. Consigo respirar melhor o dia inteiro depois.',
      'en-US': 'That time of day changes everything. I breathe better the whole day after.',
    },
    hoursAgo: 2,
    likes: 14,
    replies: [
      {
        id: 'c1r1',
        authorId: 'lucas',
        text: {
          'pt-BR': 'Mesma coisa aqui. Acordar 30 min antes valeu cada dia.',
          'en-US': 'Same here. Waking up 30 min earlier was worth every day.',
        },
        hoursAgo: 1,
        likes: 6,
      },
    ],
  },
  {
    id: 'c2',
    postId: 'p1',
    authorId: 'pedro',
    text: {
      'pt-BR': 'Recorde sem meta de ritmo é o melhor tipo de recorde. Parabéns.',
      'en-US': 'A personal best with no pace goal is the best kind. Congrats.',
    },
    hoursAgo: 2,
    likes: 9,
    replies: [],
  },
  {
    id: 'c3',
    postId: 'p1',
    authorId: 'camila',
    text: {
      'pt-BR': 'Qual foi a sensação nos últimos dois quilômetros?',
      'en-US': 'How did the last two kilometres feel?',
    },
    hoursAgo: 1,
    likes: 3,
    replies: [
      {
        id: 'c3r1',
        authorId: 'lucas',
        text: {
          'pt-BR': 'Leve. Foi a primeira vez que terminei com sobra.',
          'en-US': 'Light. First time I finished with something left.',
        },
        hoursAgo: 1,
        likes: 4,
      },
    ],
  },
  {
    id: 'c4',
    postId: 'p3',
    authorId: 'camila',
    text: {
      'pt-BR': 'Sete meses sem dor é a parte mais importante do post.',
      'en-US': 'Seven months pain-free is the most important part of this post.',
    },
    hoursAgo: 5,
    likes: 18,
    replies: [],
  },
  {
    id: 'c5',
    postId: 'p2',
    authorId: 'juliana',
    text: {
      'pt-BR': 'Comecei ontem por causa dos seus posts. Obrigada.',
      'en-US': 'I started yesterday because of your posts. Thank you.',
    },
    hoursAgo: 4,
    likes: 11,
    replies: [],
  },
]
